export default __webpack_public_path__ + "static/media/image11.ba59a4cf.png";